import React from 'react';
import styled from 'styled-components';
import { media } from '../../utils/media-queries';


const VideoVimeo = ({ url }) => {

    return (
        <StyledVideoVimeo>
            <div className="wrapper">
                <iframe src={`https://player.vimeo.com/video/${new URL(url).pathname.substring(1)}`} frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen />
            </div>
        </StyledVideoVimeo>
    );
};

const StyledVideoVimeo = styled.div`
    width:100%;
    height:auto;

    @media ${media.M} {
        grid-column: 2 / 12
    }

    .wrapper {
        position:relative;
        width:100%;
        height:0;
        padding-bottom:56.25%;

    }
    iframe {
        position:absolute;
        top:0;
        left:0;
        width:100%;
        height:100%;
    }
`;

export default VideoVimeo;